module.exports = __webpack_public_path__ + "static/media/learning.83fb4b02.png";